import { THEME_DARK, THEME_LIGHT } from "./themeConstants";
import brand from "../config/brand";

const DARK_CHROME = "#242526";

export function resolveTheme(preference) {
  return preference === THEME_DARK ? THEME_DARK : THEME_LIGHT;
}

export function chromeColor(theme) {
  if (theme === THEME_DARK) return DARK_CHROME;
  return brand.primaryColor || "#293681";
}

export function applyTheme(resolved) {
  if (typeof document === "undefined") return;
  const theme = resolveTheme(resolved);
  const root = document.documentElement;
  root.setAttribute("data-theme", theme);
  root.setAttribute("data-bs-theme", theme);
  root.style.colorScheme = theme;

  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) {
    meta.setAttribute("content", chromeColor(theme));
  }
}

export async function syncNativeStatusBar() {
  try {
    const { isNative } = await import("../utils/mobile");
    if (!isNative()) return;
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    const isDark =
      typeof document !== "undefined" &&
      document.documentElement.getAttribute("data-theme") === THEME_DARK;
    await StatusBar.setStyle({ style: isDark ? Style.Light : Style.Dark });
    await StatusBar.setBackgroundColor({
      color: isDark ? DARK_CHROME : chromeColor(THEME_LIGHT),
    });
  } catch {
    // StatusBar plugin unavailable on web / tests
  }
}
